export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const MONTH_DAY_YEAR = 'MM/DD/YYYY';
export const MONTH_DAY_YEAR_SHORT = 'MMDDYYYY';
export const EMAIL_ADDRESS_SEPARATOR = ',';
